Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LinkedInBadge", {
  enumerable: true,
  get: function get() {
    return _linkedinBadge.LinkedInBadge;
  }
});
var _linkedinBadge = require("./linkedin-badge");